<ng-select [id]="id()"
           [name]="name()"
           [items]="zones()"
           bindLabel="name"
           placeholder="ทั้งหมด"
           (ngModelChange)="onValueChange($event)"
           [(ngModel)]="value">
</ng-select>
